import { useEffect, useState } from 'react';
import landingPageAPI from '../services/landingPage';

/**
 * Whether the public home page is switched on: true, false, or null while still checking.
 * If it can't be checked it counts as on, the default, so links to it aren't lost on a blip.
 */
export default function useHomePageEnabled() {
  const [enabled, setEnabled] = useState(() => {
    const cached = landingPageAPI.peekPublic();
    return cached ? cached.enabled !== false : null;
  });

  useEffect(() => {
    let active = true;
    landingPageAPI.getPublic()
      .then((data) => { if (active) setEnabled(data?.enabled !== false); })
      .catch(() => { if (active) setEnabled(true); });
    return () => { active = false; };
  }, []);

  return enabled;
}
